/*
 * Created Date: 29-01-2024, 2:15:59 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Wed Feb 28 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import React from 'react'
import { ROUTER_MY_ACCOUNT } from './const'

const LazyProfile = React.lazy(() => import('../Profile'))

const MyAccountRouterConfig = [
	{
		auth: ['admin'],
		settings: {
			layout: {
				config: {
					sidebar: {
						display: true
					},
					header: {
						display: true
					},
					mobileHeader: {
						display: true
					}
				}
			}
		},
		routes: [
			{
				path: ROUTER_MY_ACCOUNT.profile,
				element: <LazyProfile />
			}
		]
	}
]

export default MyAccountRouterConfig
